
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useAuthStore } from '~app/core/auth';

export default defineComponent({
  name: 'menu-user',
  methods: {
    ...mapActions(useAuthStore, ['logout']),
  },
  computed: {
    ...mapState(useAuthStore, {
      email: (store) => store.user?.email,
      avatar: (store) => store.user?.email?.charAt(0),
    }),
  },
});
